<template>
  <header>
    <div
      id="header-sticky"
      :class="`${
        isSticky
          ? 'header__area header__transparent header__padding sticky'
          : 'header__area header__transparent header__padding header__shadow'
      } ${header__white && header__white}`"
    >
      <!-- <div id="header-sticky" :class="`${isSticky ? 'header__area header__transparent header__padding-2 sticky' : `${headerShadow ? headerShadow : 'header__area header__transparent header__padding-2 header__shadow'}`}`"> -->
      <div class="container-fluid">
        <div class="row align-items-center">
          <div class="col-xxl-2 col-xl-3 col-lg-4 col-md-2 col-sm-4 col-6">
            <div class="header__left d-flex align-items-center">
              <div class="logo">
                <router-link to="/">
                  <h6
                    class="mb-0 d-flex align-items-end"
                    :style="isSticky ? 'color: #0e1133' : 'color: white'"
                  >
                    <img
                      width="100"
                      height="100"
                      src="../../assets/img/logotip1.png"
                      alt=""
                    />
                    <p
                      class="ml-2 d-none"
                      :style="isSticky ? 'color: #0e1133' : 'color: white'"
                    >
                      Togʻ-kon va geologiya sohasi <br />
                      xodimlari malakasini oshirish instituti
                    </p>
                  </h6>
                </router-link>
              </div>
              <div class="header__category d-none">
                <nav>
                  <ul>
                    <li>
                      <router-link
                        to="/"
                        class="cat-menu d-flex align-items-center"
                      >
                        <div class="cat-dot-icon d-inline-block">
                          <svg viewBox="0 0 276.2 276.2">
                            <g>
                              <g>
                                <path
                                  class="cat-dot"
                                  d="M33.1,2.5C15.3,2.5,0.9,17,0.9,34.8s14.5,32.3,32.3,32.3s32.3-14.5,32.3-32.3S51,2.5,33.1,2.5z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M137.7,2.5c-17.8,0-32.3,14.5-32.3,32.3s14.5,32.3,32.3,32.3c17.8,0,32.3-14.5,32.3-32.3S155.5,2.5,137.7,2.5    z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M243.9,67.1c17.8,0,32.3-14.5,32.3-32.3S261.7,2.5,243.9,2.5S211.6,17,211.6,34.8S226.1,67.1,243.9,67.1z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M32.3,170.5c17.8,0,32.3-14.5,32.3-32.3c0-17.8-14.5-32.3-32.3-32.3S0,120.4,0,138.2S14.5,170.5,32.3,170.5z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M136.8,170.5c17.8,0,32.3-14.5,32.3-32.3c0-17.8-14.5-32.3-32.3-32.3c-17.8,0-32.3,14.5-32.3,32.3    C104.5,156.1,119,170.5,136.8,170.5z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M243,170.5c17.8,0,32.3-14.5,32.3-32.3c0-17.8-14.5-32.3-32.3-32.3s-32.3,14.5-32.3,32.3    C210.7,156.1,225.2,170.5,243,170.5z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M33,209.1c-17.8,0-32.3,14.5-32.3,32.3c0,17.8,14.5,32.3,32.3,32.3s32.3-14.5,32.3-32.3S50.8,209.1,33,209.1z    "
                                />
                                <path
                                  class="cat-dot"
                                  d="M137.6,209.1c-17.8,0-32.3,14.5-32.3,32.3c0,17.8,14.5,32.3,32.3,32.3c17.8,0,32.3-14.5,32.3-32.3    S155.4,209.1,137.6,209.1z"
                                />
                                <path
                                  class="cat-dot"
                                  d="M243.8,209.1c-17.8,0-32.3,14.5-32.3,32.3c0,17.8,14.5,32.3,32.3,32.3c17.8,0,32.3-14.5,32.3-32.3    S261.6,209.1,243.8,209.1z"
                                />
                              </g>
                            </g>
                          </svg>
                        </div>
                        <span>Category</span>
                      </router-link>
                      <ul class="cat-submenu">
                        <li>
                          <router-link to="/course-details"
                            >English Learning</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/course-details"
                            >Web Development</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/course-details"
                            >Logo Design</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/course-details"
                            >Motion Graphics</router-link
                          >
                        </li>
                        <li>
                          <router-link to="/course-details"
                            >Video Edition</router-link
                          >
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
          <div class="col-xxl-10 col-xl-9 col-lg-8 col-md-10 col-sm-8 col-6">
            <div
              class="header__right d-flex justify-content-end align-items-center"
            >
              <div class="main-menu main-menu-3">
                <nav id="mobile-menu" class="d-none d-xl-block">
                  <ul>
                    <li
                      v-for="(item, index) in formattedMenu"
                      :key="index"
                      class="mx-3"
                      :class="{
                        active: openedMenu === index,
                        'has-dropdown': item.children && item.children.length,
                      }"
                    >
                      <template v-if="item.children && item.children.length">
                        <a
                          @click="toggleMenu(index)"
                          :style="isSticky ? 'color: #0e1133' : 'color: white'"
                          >{{
                            getName({
                              nameUz: item.title_uz,
                              nameRu: item.title_ru,
                              nameEn: item.title_en,
                            })
                          }}
                        </a>
                        <ul class="submenu">
                          <li
                            v-for="(child, childIndex) in item.children
                              .filter((c) => c.status === true)
                              .sort((a, b) => a.position - b.position)"
                            :key="childIndex"
                            :class="{
                              'has-dropdown':
                                child.children && child.children.length,
                            }"
                          >
                            <template
                              v-if="child.children && child.children.length"
                            >
                              <a>
                                {{
                                  getName({
                                    nameUz: child.title_uz,
                                    nameRu: child.title_ru,
                                    nameEn: child.title_en,
                                  })
                                }}
                                <span class="arrow">›</span>
                              </a>
                              <ul class="submenu submenu--nested">
                                <li
                                  v-for="(
                                    grandChild, grandIndex
                                  ) in child.children
                                    .filter((c) => c.status === true)
                                    .sort((a, b) => a.position - b.position)"
                                  :key="grandIndex"
                                  :class="{
                                    'has-dropdown':
                                      grandChild.children &&
                                      grandChild.children.length,
                                  }"
                                >
                                  <template
                                    v-if="
                                      grandChild.children &&
                                      grandChild.children.length
                                    "
                                  >
                                    <a
                                      >{{
                                        getName({
                                          nameUz: grandChild.title_uz,
                                          nameRu: grandChild.title_ru,
                                          nameEn: grandChild.title_en,
                                        })
                                      }}
                                      <span class="arrow">›</span>
                                    </a>
                                    <ul class="submenu submenu--nested">
                                      <li
                                        v-for="(
                                          deepChild, deepIndex
                                        ) in grandChild.children
                                          .filter((c) => c.status === true)
                                          .sort(
                                            (a, b) => a.position - b.position,
                                          )"
                                        :key="deepIndex"
                                      >
                                        <router-link :to="`/${deepChild.slug}`">
                                          {{
                                            getName({
                                              nameUz: deepChild.title_uz,
                                              nameRu: deepChild.title_ru,
                                              nameEn: deepChild.title_en,
                                            })
                                          }}
                                        </router-link>
                                      </li>
                                    </ul>
                                  </template>
                                  <template v-else>
                                    <router-link
                                      :to="`/${grandChild.slug}`"
                                      :style="
                                        hoveredGrandChild === grandChild.id
                                          ? 'color: white !important'
                                          : 'color: black !important'
                                      "
                                      @mouseenter="
                                        hoveredGrandChild = grandChild.id
                                      "
                                      @mouseleave="hoveredGrandChild = null"
                                    >
                                      {{
                                        getName({
                                          nameUz: grandChild.title_uz,
                                          nameRu: grandChild.title_ru,
                                          nameEn: grandChild.title_en,
                                        })
                                      }}
                                    </router-link>
                                  </template>
                                </li>
                              </ul>
                            </template>

                            <template v-else>
                              <router-link :to="`/${child.slug}`">
                                {{
                                  getName({
                                    nameUz: child.title_uz,
                                    nameRu: child.title_ru,
                                    nameEn: child.title_en,
                                  })
                                }}
                              </router-link>
                            </template>
                          </li>
                        </ul>
                      </template>

                      <template v-else>
                        <router-link :to="`/${item.slug}`">
                          {{
                            getName({
                              nameUz: item.title_uz,
                              nameRu: item.title_ru,
                              nameEn: item.title_en,
                            })
                          }}
                        </router-link>
                      </template>
                    </li>

                    <!-- <li style="color: white;">nimadir</li> -->

                    <!-- <li v-for="(vm,index) in formattedMenu" :key="index" class="mx-3" :class="vm.children.length > 0 ? 'has-dropdown' : ''">
                      <router-link :to="vm.children.length > 0 ? '#' : `/${vm.slug}` ">{{ vm.title_uz }}</router-link>
                      <ul class="submenu" v-if="vm.children.length > 0">
                        <li v-for="(item, index1) in vm.children" :key="index1">
                          <router-link :to="`/${item.slug}`">{{ item?.title_uz }}</router-link>
                        </li>
                      </ul>
                    </li> -->

                    <li class="has-dropdown">
                      <router-link to="#">{{
                        locate == "uz"
                          ? "O'zbek"
                          : locate == "ru"
                          ? "Русский"
                          : locate == "en"
                          ? "English"
                          : "Ўзбек"
                      }}</router-link>
                      <ul class="submenu">
                        <li
                          style="cursor: pointer"
                          v-for="(vm, index) in items"
                          :key="index"
                          @click="exchange(vm.value)"
                        >
                          <a href="#">{{ vm.state }}</a>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </nav>
              </div>
              <div class="sidebar__menu d-xl-none">
                <div
                  @click="handleSidebar"
                  class="sidebar-toggle-btn ml-30"
                  id="sidebar-toggle"
                >
                  <span class="line"></span>
                  <span class="line"></span>
                  <span class="line"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- cart mini area start -->
  <div class="cartmini__area">
    <div
      :class="`${
        showMiniCart ? 'cartmini__wrapper opened' : 'cartmini__wrapper'
      }`"
    >
      <div class="cartmini__title">
        <h4>Shopping cart</h4>
      </div>
      <div @click="handleCartClose" class="cartmini__close">
        <button type="button" class="cartmini__close-btn">
          <i class="fal fa-times"></i>
        </button>
      </div>
      <div class="cartmini__widget">
        <div class="cartmini__inner">
          <ul>
            <li>
              <div class="cartmini__thumb">
                <a href="#">
                  <img src="../../assets/img/course/sm/cart-1.jpg" alt="" />
                </a>
              </div>
              <div class="cartmini__content">
                <h5>
                  <a href="#">Strategy law and organization Foundation </a>
                </h5>
                <div class="product-quantity mt-10 mb-10">
                  <span
                    @click="handleDecreaseValue('valueOne')"
                    class="cart-minus"
                    >-</span
                  >
                  <input class="cart-input" type="text" v-model="value" />
                  <span
                    @click="handleIncreaseValue('valueOne')"
                    class="cart-plus"
                    >+</span
                  >
                </div>
                <div class="product__sm-price-wrapper">
                  <span class="product__sm-price">$46.00</span>
                </div>
              </div>
              <a href="#" class="cartmini__del"><i class="fal fa-times"></i></a>
            </li>
            <li>
              <div class="cartmini__thumb">
                <a href="#">
                  <img src="../../assets/img/course/sm/cart-2.jpg" alt="" />
                </a>
              </div>
              <div class="cartmini__content">
                <h5><a href="#">Fundamentals of music theory Learn new</a></h5>
                <div class="product-quantity mt-10 mb-10">
                  <span
                    @click="handleDecreaseValue('valueTwo')"
                    class="cart-minus"
                    >-</span
                  >
                  <input class="cart-input" type="text" v-model="valueTwo" />
                  <span
                    @click="handleIncreaseValue('valueTwo')"
                    class="cart-plus"
                    >+</span
                  >
                </div>
                <div class="product__sm-price-wrapper">
                  <span class="product__sm-price">$32.00</span>
                </div>
              </div>
              <a href="#" class="cartmini__del"><i class="fal fa-times"></i></a>
            </li>
            <li>
              <div class="cartmini__thumb">
                <a href="#">
                  <img src="../../assets/img/course/sm/cart-3.jpg" alt="" />
                </a>
              </div>
              <div class="cartmini__content">
                <h5>
                  <a href="#">Strategy law and organization Foundation </a>
                </h5>
                <div class="product-quantity mt-10 mb-10">
                  <span
                    @click="handleDecreaseValue('valueThree')"
                    class="cart-minus"
                    >-</span
                  >
                  <input class="cart-input" type="text" v-model="valueThree" />
                  <span
                    @click="handleIncreaseValue('valueThree')"
                    class="cart-plus"
                    >+</span
                  >
                </div>
                <div class="product__sm-price-wrapper">
                  <span class="product__sm-price">$62.00</span>
                </div>
              </div>
              <a href="#" class="cartmini__del"><i class="fal fa-times"></i></a>
            </li>
          </ul>
        </div>
        <div class="cartmini__checkout">
          <div class="cartmini__checkout-title mb-30">
            <h4>Subtotal:</h4>
            <span>$113.00</span>
          </div>
          <div class="cartmini__checkout-btn">
            <router-link to="/cart" class="e-btn e-btn-border mb-10 w-100">
              <span></span> view cart</router-link
            >
            <router-link to="/checkout" class="e-btn w-100">
              <span></span> checkout</router-link
            >
          </div>
        </div>
      </div>
    </div>
  </div>

  <div
    @click="handleCartClose"
    :class="[showMiniCart ? 'body-overlay opened' : 'body-overlay']"
  ></div>
  <!-- cart mini area end -->

  <!-- sidebar area start -->
  <div
    :class="`${showSidebar ? 'sidebar__area sidebar-opened' : 'sidebar__area'}`"
  >
    <div class="sidebar__wrapper">
      <div @click="handleSidebarClose" class="sidebar__close">
        <button class="sidebar__close-btn" id="sidebar__close-btn">
          <span><i class="fal fa-times"></i></span>
          <span>close</span>
        </button>
      </div>
      <div class="sidebar__content">
        <div class="logo mb-40">
          <router-link to="/">
            <img src="../../assets/img/logo/logo.png" alt="logo" />
          </router-link>
        </div>

        <div class="side-info-content sidebar-menu mm-menu">
          <ul>
            <li
              v-for="(item, index) in formattedMenu"
              :key="index"
              class="menu-item-has-children"
              :class="{
                active: openedMenu === index,
                'has-droupdown': item.children && item.children.length,
              }"
            >
              <template v-if="item.children && item.children.length">
                <a @click="toggleMenu(index)">{{
                  getName({
                    nameUz: item.title_uz,
                    nameRu: item.title_ru,
                    nameEn: item.title_en,
                  })
                }}</a>
                <ul class="sub-menu" :class="{ active: openedMenu === index }">
                  <li
                    v-for="(child, childIndex) in item.children
                      .filter((c) => c.status === true)
                      .sort((a, b) => a.position - b.position)"
                    :key="childIndex"
                  >
                    <router-link :to="`/${child.slug}`">{{
                      getName({
                        nameUz: child.title_uz,
                        nameRu: child.title_ru,
                        nameEn: child.title_en,
                      })
                    }}</router-link>
                  </li>
                </ul>
              </template>

              <template v-else>
                <router-link :to="`/${item.slug}`">{{
                  getName({
                    nameUz: item.title_uz,
                    nameRu: item.title_ru,
                    nameEn: item.title_en,
                  })
                }}</router-link>
              </template>
            </li>
          </ul>
        </div>

        <div class="sidebar__search p-relative mt-40">
          <form action="#">
            <input type="text" placeholder="Search..." />
            <button type="submit"><i class="fad fa-search"></i></button>
          </form>
        </div>
        <div class="sidebar__cart mt-30">
          <a href="#">
            <div class="header__cart-icon">
              <svg viewBox="0 0 24 24">
                <circle class="st0" cx="9" cy="21" r="1" />
                <circle class="st0" cx="20" cy="21" r="1" />
                <path
                  class="st0"
                  d="M1,1h4l2.7,13.4c0.2,1,1,1.6,2,1.6h9.7c1,0,1.8-0.7,2-1.6L23,6H6"
                />
              </svg>
            </div>
            <span class="cart-item">2</span>
          </a>
        </div>
      </div>
    </div>
  </div>
  <div
    @click="handleSidebarClose"
    :class="[showSidebar ? 'body-overlay opened' : 'body-overlay']"
  ></div>
  <!-- sidebar area end -->
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import BlogMixin from "../../mixins/blogMixin";

export default {
  name: "HomeHeader",
  mixins: [BlogMixin],

  props: {
    header__white: String,
  },
  data() {
    return {
      locate: localStorage.getItem("locale") || "uz",
      isSticky: false,
      openedMenu: null,
      hoveredGrandChild: null,
      showMiniCart: false,
      showSidebar: false,
      value: 1,
      valueTwo: 1,
      valueThree: 1,
      menuOption: {
        menuShow: false,
        menuSearch: false,
        homeDropdown: false,
        coursesDropdown: false,
        pagesDropDown: false,
        blogDropdown: false,
        aboutDropdown: false,
      },
      items: [
        { flag: "lat", state: "O'zbek", value: "uz", appear: true },
        // { flag: "crill", state: "Ўзбек", value: "uz", appear: true },
        { flag: "russia", state: "Русский", value: "ru", appear: true },
        { flag: "english", state: "English", value: "en", appear: true },
      ],
    };
  },
  computed: {
    ...mapGetters("menu", ["menu"]),
    formattedMenu() {
      const menuMap = new Map();

      this.menu.forEach((item) => {
        menuMap.set(item.id, { ...item, children: [] });
      });

      this.menu.forEach((item) => {
        if (item.parent !== null) {
          const parent = menuMap.get(item.parent);
          if (parent) {
            parent.children.push(menuMap.get(item.id));
          }
        }
      });

      return [...menuMap.values()]
        .filter((item) => item.parent === null && item.status === true)
        .sort((a, b) => a.position - b.position);
    },
  },
  created() {
    this.getMenu();
  },
  methods: {
    ...mapActions("menu", ["getMenu"]),

    toggleMenu(index) {
      this.openedMenu = this.openedMenu === index ? null : index;
    },

    exchange(locale = "uz") {
      localStorage.setItem("locale", locale);
      this.$i18n.locale = locale;
      this.locate = localStorage.getItem("locale");
    },
    handleSticky() {
      if (window.scrollY > 80) {
        this.isSticky = true;
      } else {
        this.isSticky = false;
      }
    },
    handleMiniCart() {
      this.showMiniCart = true;
    },
    handleCartClose() {
      this.showMiniCart = false;
    },
    handleSidebar() {
      this.showSidebar = true;
    },
    handleSidebarClose() {
      this.showSidebar = false;
    },
    handleIncreaseValue(value) {
      if (value === "valueOne") {
        this.value++;
      }
      if (value === "valueTwo") {
        this.valueTwo++;
      }
      if (value === "valueThree") {
        this.valueThree++;
      }
    },
    handleDecreaseValue(value) {
      if (value === "valueOne" && this.value > 0) {
        this.value--;
      }
      if (value === "valueTwo" && this.valueTwo > 0) {
        this.valueTwo--;
      }
      if (value === "valueThree" && this.valueThree > 0) {
        this.valueThree--;
      }
    },
  },
  mounted() {
    window.addEventListener("scroll", this.handleSticky);
  },
};
</script>
<style scoped lang="scss">
::v-deep .main-menu-3 ul li a {
  color: #0e1133 !important;
}
::v-deep .main-menu ul li.has-dropdown > a::after {
  color: #0e1133 !important;
}
/* ::v-deep .main-menu-3 ul li:hover a{
  color: #0e1133 !important;
}*/
.main-menu ul li .submenu li a {
  color: #0e1133;
}
.main-menu ul li .submenu li:hover a {
  color: white !important;
}
::v-deep .main-menu ul li .submenu {
  position: absolute;
  left: -96px;
}

.menu-item-has-children {
  display: block !important;
}

.menu-item-has-children .sub-menu,
.menu-item-has-children .submenu {
  position: static !important;
  width: 100% !important;
  opacity: 1 !important;
  visibility: visible !important;
  box-shadow: none !important;
  display: none;
}

.menu-item-has-children.active .sub-menu,
.menu-item-has-children.active .submenu {
  display: block;
}

.menu-item-has-children .sub-menu li,
.menu-item-has-children .submenu li {
  display: block;
  width: 100%;
}
/* Nested submenu - hover bilan o'ngga chiqadi */
.submenu--nested {
  display: none;
  position: absolute;
  left: 100%;
  top: 0;
  min-width: 220px;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  z-index: 999;
}

.has-dropdown {
  position: relative;
}

.has-dropdown:hover > .submenu--nested {
  display: block;
}

.arrow {
  float: right;
  font-style: normal;
}
</style>
